// src/components/3 - Modal/2 - Messages Modals/DeleteChannelModal.js

import React, { useState, useContext } from "react";
import { Button, Input, Text, useColorModeValue } from "@chakra-ui/react";
import ReusableModal from "../9 - General Modals/ReusableModal";
import { MessagesContext } from "../../5 - General/Context/MessagesContext";
import { useNavigate } from "react-router-dom";
import { WorkspaceContext } from "../../5 - General/Context/WorkspaceContext";

const DeleteChannelModal = ({ isOpen, onClose }) => {
  const { handleDeleteChannel } = useContext(MessagesContext);
  const [confirmationText, setConfirmationText] = useState("");
  const isTypedField = confirmationText === "delete";
  const { themeColor } = useContext(WorkspaceContext); // Accessed themeColor
  const navigate = useNavigate();

  const footerButtons = (
    <>
      <Button onClick={onClose} colorScheme='gray' variant='outline'>
        {" "}
        {/* Replaced "primary" with themeColor */}
        Cancel
      </Button>
      <Button
        colorScheme={isTypedField ? "red" : "gray"} // "red" remains for destructive action
        onClick={() => {
          if (isTypedField) {
            handleDeleteChannel();
            onClose();
            navigate("/dashboard/messages");
          }
        }}
        isDisabled={!isTypedField}
      >
        Delete
      </Button>
    </>
  );

  return (
    <ReusableModal isOpen={isOpen} onClose={onClose} title="Delete Conversation" footerButtons={footerButtons}>
      <Text mt={5} mb={5} fontSize="md">
        Enter <b>"delete"</b> in the box below to confirm. This action cannot be undone and will permanently delete messages and related files.
      </Text>
      <Input
        type="text"
        value={confirmationText}
        onChange={(e) => setConfirmationText(e.target.value)}
        placeholder="Type 'delete' to confirm"
        px={4}
        boxShadow='base'
        _focus={{ boxShadow: "md", border: `1px solid`, boxSizing: "border-box", borderColor: `${themeColor}.500` }} // Updated with themeColor
        borderColor={useColorModeValue("gray.300", "gray.600")}
      />
    </ReusableModal>
  );
};

export default DeleteChannelModal;
